export { PHASE_VAR, phaseVar } from './phase';
export type { PhaseName } from './phase';

export type ThemeName = 'cream' | 'light' | 'dark';
export type DensityName = 'compact' | 'regular' | 'comfortable';

export const THEMES: ThemeName[] = ['cream', 'light', 'dark'];
export const DENSITIES: DensityName[] = ['compact', 'regular', 'comfortable'];
